package io.horion.cv.api.datasource.cv

import kotlinx.serialization.Serializable

@Serializable
enum class Level(val num: Float) {
    BEGINNER(num = 0.2f),
    INTERMEDIATE(num = 0.4f),
    GOOD(num = 0.6f),
    VERY_GOOD(num = 0.8f),
    EXCELLENT(num = 1.0f)
}